export const PrintSuccess = (message: string) => {
  const toast = useToast()
  toast.add({ title: message, color: 'success', duration: 3000 })
}

export const PrintError = (message: string) => {
  const toast = useToast()
  toast.add({ title: message, color: 'error', duration: 5000 })
}
